<!--
@Author: MIYONGLE
@Desc: PC端底部
@Date: 2021-04-16 18时
-->
<template>
  <div class="posi-bottom">
    <!--底部-->
    <div class="bottom-bg">
      <div class="min-width-pc">
        <div class="bottom-foot">
          <div class="bottom-foot-sec1">
            <div
              class="bottom-foot-item"
              v-for="(item, index) in footList"
              :key="index"
            >
              <p>{{ item.name }}</p>
              <div
                class="span-text"
                v-for="(itemSon, val) in item.itemList"
                :key="val"
                @click="jumpNav(item, itemSon)"
              >
                <span v-if="icpBtn && itemSon.title == '新闻中心'"
                  >资讯中心</span
                >
                <span v-else>{{ itemSon.title }}</span>
              </div>
            </div>
          </div>

          <div class="bottom-foot-sec2">
            <span>联系我们</span>
            <span class="bottom-sec2-text"
              ><img src="../../static/pc/ic_home_phone.png" />400-085-5500</span
            >
            <span class="bottom-sec2-text"
              ><img
                src="../../static/pc/ic_home_mail.png"
              />market@hvyogo.com</span
            >
            <span class="bottom-sec2-text"
              ><img src="../../static/pc/ic_address.png" />{{
                companyAddress
              }}</span
            >
          </div>

          <div class="bottom-foot-sec3" v-if="!isPCextension">
            <img src="../../static/pc/footer_img_wechat.png" alt="" />
            <span>慧用工公众号</span>
          </div>

          <div class="bottom-foot-sec4" v-if="!isPCextension">
            <img src="../../static/pc/footer_img_wechat_dl.png" alt="" />
            <span>代理助手小程序</span>
          </div>
        </div>
      </div>
      <span class="line"></span>

      <div class="bottom-foot-copy clearfix min-width-pc">
        <span
          >Copyright© {{ timeYear }} {{ whichCompName }} ｜
          <a href="https://beian.miit.gov.cn" target="_blank">{{ icpText }}</a>
        </span>

        <div class="plice" v-if="policeText">
          <a target="_blank" :href="policeUrl">
            <img src="../../static/pc/备案图标.png" />
            <span>{{ policeText }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { changeJumpPageUrl } from "../filters/filters";
import { FOOT_CON_LIST } from "../service/businessConsts";
import { setSession } from "../filters/filters";

export default {
  name: "foot",
  inject: ["reload"], // 引入刷新方法

  data() {
    return {
      setting: "",
      footList: FOOT_CON_LIST,
      icpText: "",
      whichHostName: "",
      whichCompName: "",
      policeText: "",
      policeUrl: "",
      companyAddress: "",
      icpBtn: false, //只有在慧薪下用此处改成fasle，
      timeYear: "",
      isPCextension: false //PC端定制推广页特殊展示
    };
  },

  created() {
    let pathTemp = window.location.hash;
    let path = pathTemp.substring(1, pathTemp.length);
    if (path === "/extensionPage") {
      this.isPCextension = true;
    }
    this.setting = process.env.NODE_ENV;
    this.timeYear = new Date().getFullYear();
    // 只在慧薪域名下弹ICP处理用的二维码
    this.whichAddress = window.location.hostname;
    if (
      this.whichAddress === "www.hvcin.com" ||
      this.whichAddress === "hvcin.com"
    ) {
      this.icpBtn = true;
    }

    let compInfo = this.getSiteAddress();
    this.icpText = compInfo.whichIcp;
    this.whichHostName = compInfo.whichHui;
    this.whichCompName = compInfo.whichCompName;
    this.policeText = compInfo.policeText;
    this.policeUrl = compInfo.policeUrl;
    this.companyAddress = compInfo.companyAddress;
  },

  mounted() {},

  methods: {
    jumpNav(item, itemSon) {
      // 点首页点id
      if (item.name == "首页") {
        this.$router.push({
          path: changeJumpPageUrl(item.path),
          query: {
            from: itemSon.id
          }
        });
      } else {
        var path = window.location.hash;
        this.$router.push({
          path:
            path.indexOf("source") > 0
              ? changeJumpPageUrl(itemSon.path)
              : itemSon.path
        });

        setSession("aboutTabId", itemSon.id);
      }

      eventBus.$emit("brotherClickNav", item, itemSon);
      this.reload();
    }
  }
};
</script>

<style scoped="scoped" lang="scss">
.posi-bottom {
  position: absolute;
  width: 100%;
  min-width: 1300px;
}
.bottom-bg {
  background: #191919;
  height: 350px;
  min-width: 1300px;
  box-sizing: border-box;
}

.bottom-foot {
  border-bottom: 1px solid #39424d;
  color: #78818c;
  width: 1200px;
  padding-top: 82px;
  margin: 0 auto;
  display: flex;
  box-sizing: border-box;
  .bottom-foot-sec1 {
    display: flex;
    .bottom-foot-item:not(:first-child) {
      margin-left: 30px;
    }
    .bottom-foot-item:nth-child(2) {
      margin-left: 10px;
    }

    .bottom-foot-item:nth-child(3) {
      margin-left: 30px;
    }

    .bottom-foot-item {
      text-align: left;
      margin-bottom: 60px;
      width: 98px;
      p {
        font-size: 18px;
        color: #ffffff;
        cursor: pointer;
        margin-bottom: 23px;
      }
      .span-text {
        font-size: 16px;
        color: #78818c;
        display: block;
        margin-bottom: 8px;
        cursor: pointer;
      }
      span:hover {
        color: #868c94;
      }
    }
    p {
      font-size: 16px;
      color: #78818c;
      letter-spacing: 0;
      line-height: 28px;
      text-align: left;
    }
  }
  .bottom-foot-sec2 {
    margin-left: 90px;
    span {
      display: block;
    }
    span:nth-child(1) {
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 26px;
      text-align: left;
      margin-bottom: 26px;
    }
    .bottom-sec2-text {
      font-size: 18px;
      color: #78818c;
      letter-spacing: 0;
      line-height: 22px;
      text-align: left;
      margin-top: 16px;
      img {
        width: 22px;
        height: 22px;
        margin-right: 10px;
        float: left;
      }
    }

    span:nth-child(4) {
      font-size: 16px;
    }
  }

  .bottom-foot-sec3,
  .bottom-foot-sec4 {
    width: 120px;
    height: 120px;
    margin-left: 40px;
    img {
      width: 100%;
      display: block;
    }
    span {
      font-size: 12px;
      color: #78818c;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      margin-top: 10px;
      display: block;
    }
  }
  .bottom-foot-sec4 {
    margin-left: 35px;
  }
}
.bottom-foot-copy {
  margin: 20px auto;
  width: 1300px;
  box-sizing: border-box;

  span:nth-child(1) {
    float: left;
    font-size: 14px;
    color: #78818c;
    letter-spacing: 0;
    line-height: 20px;
    a {
      color: #78818c;
    }
  }
  span:nth-child(2) {
    float: right;
    font-size: 14px;
    color: #0077ff;
    letter-spacing: 0;
    line-height: 20px;
    display: inline-block;
    height: 20px;
  }
  .plice {
    display: inline-block;
    float: right;
    img {
      vertical-align: middle;
    }
    a {
      color: #78818c;
      span {
        height: 32px;
        line-height: 32px;
        display: inline-block;
        position: relative;
        top: -5px;
        left: 2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue